import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
export function PainAgitation() {
  const pains = [{
    icon: '😴',
    text: 'Te despiertas cansado aunque hayas dormido 8 horas'
  }, {
    icon: '🧠',
    text: 'Tienes esa "niebla mental" que no te deja pensar con claridad'
  }, {
    icon: '🦴',
    text: 'Tus articulaciones duelen más con cada año que pasa'
  }, {
    icon: '💊',
    text: 'Tomas más pastillas de las que te gustaría admitir'
  }, {
    icon: '😤',
    text: 'Tu médico te dice que "es normal para tu edad"'
  }, {
    icon: '🔍',
    text: 'Has probado suplementos del mercado y no notas diferencia'
  }, {
    icon: '💸',
    text: 'Gastas dinero en vitaminas que terminan en el fondo del cajón'
  }];
  return <section className="py-16 px-4 bg-[#F0F4EC] text-center border-t border-[#E8DFD0]" data-id="element-359">
      <div className="max-w-[800px] mx-auto" data-id="element-360">
        {/* Pain Points Grid */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-361">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#2C1810] mb-10" data-id="element-362">
            ¿Te suena familiar alguna de estas situaciones?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left" data-id="element-363">
            {pains.map((pain, i) => <div key={i} className="bg-white p-4 rounded-xl border border-[#E8DFD0] shadow-sm flex items-start gap-4 hover:border-[#2D5A3D]/30 transition-colors" data-id="element-364">
                <span className="text-2xl shrink-0" data-id="element-365">{pain.icon}</span>
                <p className="text-[#5C4A3A] font-medium" data-id="element-366">{pain.text}</p>
              </div>)}
          </div>
        </motion.div>

        {/* Bridge Line */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-4" data-id="element-367">
          <p className="text-[#5C4A3A] text-sm md:text-base font-medium" data-id="element-368">
            No es tu culpa. El problema es que nadie te enseñó a usar las
            plantas{' '}
            <span className="font-bold underline decoration-[#C17817] decoration-2 underline-offset-2" data-id="element-369">
              CORRECTAMENTE
            </span>
            .
          </p>
          <p className="text-xl md:text-2xl font-serif font-bold text-[#C17817]" data-id="element-370">
            Eso está a punto de cambiar.
          </p>
          <div className="flex justify-center pt-4" data-id="element-371">
            <ArrowDown className="w-5 h-5 text-[#C17817] animate-bounce" data-id="element-372" />
          </div>
        </motion.div>
      </div>
    </section>;
}